const layout=props=>{
    return (
        <div className="container mt-5 mb-5">
            {props.children}
        </div>
    )
}
export default layout;